import { memo } from "react";
import HashKeysEmptyState from "./HashKeysEmptyState";
import HashKeysList from "./HashKeysList";
import type {
  UIHashKey,
  SelectionState,
  HashKeyActions,
} from "@/features/auth/types/hashKeys.types";

interface HashKeysContentProps {
  hashKeys: UIHashKey[];
  selectionState: SelectionState;
  actions: HashKeyActions;
  searchQuery: string;
  onClearSearch: () => void;
  isDeleting?: boolean;
}

/**
 * Main content component that handles the display of hash keys or empty state
 */
const HashKeysContent = memo<HashKeysContentProps>(
  ({
    hashKeys,
    selectionState,
    actions,
    searchQuery,
    onClearSearch,
    isDeleting,
  }) => {
    if (hashKeys.length === 0) {
      return (
        <HashKeysEmptyState
          searchQuery={searchQuery}
          onClearSearch={onClearSearch}
        />
      );
    }

    return (
      <HashKeysList
        hashKeys={hashKeys}
        selectionState={selectionState}
        actions={actions}
        isDeleting={isDeleting}
      />
    );
  },
);

HashKeysContent.displayName = "HashKeysContent";

export default HashKeysContent;
